export default "__VITE_ASSET__ChmzpALG__"